import {cookies} from "@/util";
import authRoutes from "@/http/auth-routes";
const { fetch: originalFetch } = window;

(function () {
    window.http = {
        withCredentials: false,

        withXSRFToken: false,

        mode: 'cors', // `cors`, `no-cors`, `same-origin`

        defaults: {
            headers: {
                common: {
                    //
                },
            },
        },

        interceptors: {
            request: () => {},
            response: () => {},
        },

        get: async (url, query = null) => {
            return window.http.fetch(`${url}${query ? `?${queryString(query)}` : ''}`, {
                method: 'GET',
                mode: window.http.mode,
                credentials: window.http.withCredentials ? 'include' : 'same-origin',
                headers: {
                    ...window.http.defaults.headers.common,
                },
            });
        },

        post: async (url, body, formData = false) => {
            const headers = {
                ...window.http.defaults.headers.common,
            };

            if (formData) {
                delete headers['Content-Type'];
            }

            return window.http.fetch(url, {
                method: 'POST',
                body: formData ? body : JSON.stringify(body),
                mode: window.http.mode,
                credentials: window.http.withCredentials ? 'include' : 'same-origin',
                headers,
            });
        },

        delete: async (url, body) => {
            return window.http.fetch(url, {
                method: 'DELETE',
                mode: window.http.mode,
                credentials: window.http.withCredentials ? 'include' : 'same-origin',
                headers: {
                    ...window.http.defaults.headers.common,
                },
            });
        },

        fetch: async (...args) => {
            let [resource, config] = args;

            window.http.interceptors.request();

            const res = await response(
                await originalFetch(resource, config)
            );

            window.http.interceptors.response(res);

            return res;
        },
    };

    window.http.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };
    window.http.withCredentials = true;
    window.http.withXSRFToken = true;

    window.http.interceptors.request = () => {
        const csrfToken = cookies.get('XSRF-TOKEN');
        if (csrfToken) {
            window.http.defaults.headers.common['X-XSRF-TOKEN'] = decodeURI(csrfToken);
        }

        const authToken = cookies.get('chat_api_token');
        if (authToken) {
            window.http.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        }
    };

    window.http.interceptors.response = (res) => {
        if ([401, 419].includes(res.statusCode)) {
            cookies.delete('chat_api_token');
            cookies.delete('api_token');
            cookies.delete('XSRF-TOKEN');

            if (!res.isAuthRoute && !window.location.href.includes('login')) {
                window.location.href = '/login';
            }
        }

        return res;
    };

})();

function queryString(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p) && obj[p]) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}

async function response(res) {
    let json = {};

    try {
        json = await res.json();
    } catch (e) {
        return {
            url: res.url,
            success: res.ok,
            data: res.data || null,
            statusCode: res.status,
            statusText: res.statusText,
        };
    }

    let schema = {
        url: res.url,
        isAuthRoute: authRoutes.findIndex(e => res.url.includes(e)) >= 0,
        success: res.ok,
        data: json || null,
        statusCode: res.status,
        statusText: res.statusText,
        message: '',
        errors: !res.ok ? json : null,
    };

    if (!schema.success) {
        // const httpResponse = res.response;
        // schema.message = httpResponse.data.message || '';
        // schema.errors = httpResponse.data.errors || null
        // schema.statusCode = httpResponse.status;
        // schema.statusText = httpResponse.statusText;
    }

    if (schema.statusCode === 429) {
        schema.message = 'Too many attempts. Please try again in a few moments.';
    } else if (schema.statusCode === 419) {
        schema.message = 'Service temporarily unavailable';
    } else {
        if (json.message) {
            if (typeof json.message === 'object') {
                schema.message = json.message[0];
            } else {
                schema.message = json.message;
            }
        }
    }

    return {
        ...schema,
        firstError: () => schema.errors ? schema.errors[Object.keys(schema.errors)[0]][0] : '',
    };
};
